import FacebookAuth from "../components/FacebookAuth";
import GoogleAuth from "../components/GoogleAuth";

import { SIGN_IN } from "../gql/AuthQueries";

import {
  required,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";

export default {
  name: "sign_in",

  data() {
    return {
      login: "",
      password: "",

      submitLoading: false
    };
  },

  validations() {
    let params = {
      login: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(256)
      },

      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(16)
      }
    };

    if (this.isLoginEmail) {
      params.login = {
        required,
        email,
        minLength: minLength(5),
        maxLength: maxLength(256)
      };
    }

    return params;
  },

  computed: {
    isLoginEmail() {
      return this.login.indexOf("@") > -1;
    }
  },

  // props: [],

  // mounted: function() {},

  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitLoading = true;

        this.$apollo
          .mutate({
            mutation: SIGN_IN,
            variables: {
              login: this.login,
              password: this.password
            }
          })
          .then(({ data: { signIn: { user, accessToken } } }) => {
            if (typeof localStorage !== "undefined" && accessToken) {
              localStorage.setItem("AUTH_TOKEN", accessToken);
            }

            this.$store.dispatch("initUser", user);

            // if First name empty -> go to personalize page
            let routeName = user.firstName ? "home" : "personalize";

            this.$router.push({ name: routeName });
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    }
  },

  components: {
    FacebookAuth,
    GoogleAuth
  }
};
